<template>
    <div class="dark-mode" v-shortkey="{mac: ['ctrl', 'shift', 'd'], win: ['meta', 'shift', 'd']}" @shortkey="toggle">
        <div v-if="enabled && useSvg">
            <svg id="dark-reader-svg" style="height: 0px; width: 0px;"><filter id="dark-reader-filter" x="0" y="0" width="99999" height="99999" style="color-interpolation-filters: sRGB;"><feColorMatrix type="matrix" values="0.171 -0.582 -0.703 0.000 1.220 -0.649 0.253 -0.687 0.000 1.186 -0.628 -0.574 0.174 0.000 1.126 0.000 0.000 0.000 1.000 0.000"></feColorMatrix></filter><filter id="dark-reader-reverse-filter" x="0" y="0" width="99999" height="99999" style="color-interpolation-filters: sRGB;"><feColorMatrix type="matrix" values="0.333 -0.667 -0.667 0.000 1.000 -0.667 0.333 -0.667 0.000 1.000 -0.667 -0.667 0.333 0.000 1.000 0.000 0.000 0.000 1.000 0.000"></feColorMatrix></filter></svg>
        </div>
    </div>
</template>

<script>
import * as _ from 'lodash'
import bowser from 'bowser'
import config from '../../config'
import cookie from 'react-cookie'
import messageBus from '../../KnowledgeBus'

const COOKIE_DOMAIN = config.COOKIE_DOMAIN
const COOKIE_NAME = `${config.COOKIE_NAME_PREFIX}_dark_mode`

export default {
  data () {
    return {
      enabled: cookie.load(COOKIE_NAME) === '1'
    }
  },

  computed: {
    useSvg () {
      const browser = bowser.getParser(window.navigator.userAgent)
      const browserName = _.toLower(browser.getBrowserName())

      return _.includes(['firefox'], browserName)
    }
  },

  created () {
    messageBus.$on('toggle-dark-mode', this.toggle)
  },

  beforeDestroy () {
    messageBus.$off('toggle-dark-mode', this.toggle)
  },

  mounted () {
    this.applyBodyClass(this.enabled)
  },

  methods: {
    toggle () {
      this.enabled = !this.enabled
      cookie.save(COOKIE_NAME, this.enabled ? '1' : '0', _.assign({ path: '/' }, { domain: COOKIE_DOMAIN }))
      // localStorage.setItem('darkMode', this.enabled ? '1' : '0');
      this.applyBodyClass(this.enabled)
    },

    applyBodyClass (state) {
      const method = state ? 'add' : 'remove'
      document.querySelector('html').classList[method](this.useSvg ? 'dark-svg' : 'dark')
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .dark-mode {
        height: 0;
    }
</style>

<style lang="scss" rel="stylesheet/scss">

    @media screen {

        /* Leading rule */
        html.dark {
            -webkit-filter: invert(100%) hue-rotate(180deg) !important;
            filter: invert(100%) hue-rotate(180deg) !important;

            /* Reverse rule */
            iframe,
            img,
            video,
            :not(object):not(body)>embed,
            object,
            svg image,
            [style*="background:url"],
            [style*="background-image:url"],
            [style*="background: url"],
            [style*="background-image: url"],
            [background],
            #Emojis .container-emoji .grid-emojis span,
            twitterwidget {
                -webkit-filter: invert(100%) hue-rotate(180deg) !important;
                filter: invert(100%) hue-rotate(180deg) !important;
            }

            [style*="background:url"] *,
            [style*="background-image:url"] *,
            [style*="background: url"] *,
            [style*="background-image: url"] *,
            input,
            [background] *,
            img[src^="https://s0.wp.com/latex.php"],
            twitterwidget .NaturalImage-image {
                -webkit-filter: none !important;
                filter: none !important;
            }
            .compatibility-with-darkreader-below-4-3-3 {
                background: white !important;
            }

            /* Text contrast */
            // html {
            text-shadow: 0 0 0 !important;
            //}

            /* Full screen */
            :-webkit-full-screen, :-webkit-full-screen * {
                -webkit-filter: none !important;
                filter: none !important;
            }
            :-moz-full-screen, :-moz-full-screen * {
                -webkit-filter: none !important;
                filter: none !important;
            }
            :fullscreen, :fullscreen * {
                -webkit-filter: none !important;
                filter: none !important;
            }

            /* Page background */
            // html {
            background: rgb(27,26,25) !important;
            // }

            /* Custom rules */
            .compatibility-with-darkreader-below-4-3-3 {
                background: white !important;
            }

            // /* FB rules */
            .bot-icon-wrap .bot-icon-content .bot-icon-img {
                -webkit-filter: none !important;
                filter: none !important;
            }

            // do we need a bit different filter then reverse-rule above?
            .app-header,
            .app-header .logo-section {
                -webkit-filter: invert(100%) hue-rotate(180deg) brightness(100%) contrast(90%) !important;
                filter: invert(100%) hue-rotate(180deg) brightness(100%) contrast(90%) !important;
            }
        }

        /* Leading rule */
        html.dark-svg {
            -webkit-filter: url(#dark-reader-filter) !important;
            filter: url(#dark-reader-filter) !important;
            /* Reverse rule */
            img,
            video,
            :not(object):not(body)>embed,
            object,
            svg image,
            [style*="background:url"],
            [style*="background-image:url"],
            [style*="background: url"],
            [style*="background-image: url"],
            [background],
            twitterwidget,
            #Emojis .container-emoji .grid-emojis span,
            .app-header,
            .app-header * {
                -webkit-filter: url(#dark-reader-reverse-filter) !important;
                filter: url(#dark-reader-reverse-filter) !important;
            }
            [style*="background:url"] *,
            [style*="background-image:url"] *,
            [style*="background: url"] *,
            [style*="background-image: url"] *,
            input,
            [background] *,
            img[src^="https://s0.wp.com/latex.php"],
            twitterwidget .NaturalImage-image {
                -webkit-filter: none !important;
                filter: none !important;
            }
            .compatibility-with-darkreader-below-4-3-3 {
                background: white !important;
            }

            /* Text contrast */
            // html {
            text-shadow: 0 0 0 !important;
            // }

            /* Full screen */
            :-webkit-full-screen, :-webkit-full-screen * {
            -webkit-filter: none !important;
                filter: none !important;
            }
            :-moz-full-screen, :-moz-full-screen * {
            -webkit-filter: none !important;
                filter: none !important;
            }
            :fullscreen, :fullscreen * {
            -webkit-filter: none !important;
                filter: none !important;
            }

            /* Page background */
            // html {
            background: rgb(27,26,25) !important;
            // }

            /* Custom rules */
            .compatibility-with-darkreader-below-4-3-3 {
                background: white !important;
            }

            .bot-icon-wrap .bot-icon-content .bot-icon-img,
            .app-header button.header-select.has-dropdown .ui-button__content,
            .app-header .ui-toolbar__right button.ui-button .ui-button__content .selected-emoji,
            .app-header .header-links button.active-btn .ui-button__content a {
                -webkit-filter: none !important;
                filter: none !important;
            }
        }
    }

</style>
